import React, { useEffect, useState } from 'react';
import { WizardStep } from './Wizard/Wizard';
import { FormControl } from 'floorplan/components/v2/Form';
import { FormRadioGrid } from 'floorplan/components/Form';
import { Button } from 'floorplan/components/v2/Button';
import './NumberedQuestionWizardStep.scss'

type NumberedQuestionWizardStepProps = {
    question: string;
    form: any;
    field: string;
    error: any;
    errorText: string;
    onValidate: () => any;
    onUpdate: (option: number) => any;
    min: number;
    minLabel: string;
    max: number;
    maxLabel: string;
};

const NumberedQuestionWizardStep: React.FC<NumberedQuestionWizardStepProps> = (props) => {
    const { question, form, field, error, errorText, onValidate, onUpdate, maxLabel, minLabel, min, max } = props;

    const [options, setOptions] = useState([]);

    useEffect(() => {
        setOptions([]);

        for (let i = min; i <= max; i++) {
            setOptions(o => [...o, { label: i.toString(), value: i }
            ]);
        }
        
    }, [min, max]);

    return (
        <WizardStep>
            <div className="step-wrapper">                
                <div className="modal-main">
                    <div>
                        <img src={require('@assets/op-logo.svg')} className="logo" />
                    </div>
                    <div className="highlight" style={{ margin: "8px" }}>
                        {question}
                    </div>
                    <div className="modal-body">
                        <div className="answer-container">
                            <div className="answer-bottom-range">
                                <label>{minLabel}</label>
                            </div>
                            <div className="answer-options">
                                {options && options.length > 0 && (
                                    <FormControl
                                        id='form-radio-post-inspection-survey'                                        
                                        name='form-radio-post-inspection-survey'
                                        value={form[field]}
                                        hasError={error[field]}
                                        errorText={error[field] ? errorText : ''}
                                        onChange={e => onUpdate(Number(e.target.value))}
                                    >
                                        <FormRadioGrid
                                            columns={max}
                                            bp='desktop'
                                        >
                                            {options.map((option, index) => (
                                                <FormRadioGrid.Option
                                                    id={`form-radio-post-inspection-survey-option-${index}`}
                                                    key={`form-radio-post-inspection-survey-option-${index}`}
                                                    label={option.label}
                                                    value={option.value}
                                                    checked={form[field] === option.value}
                                                />))}
                                        </FormRadioGrid>
                                    </FormControl>)}
                            </div>
                            <div className="answer-top-range">
                                <label>{maxLabel}</label>
                            </div>
                        </div>
                        <div className="btn-wrapper pt-2">
                            <Button
                                id="post-inspection-0288"
                                large
                                disabled={!form[field]}
                                onClick={() => onValidate()}
                            >
                                Continue
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </WizardStep>
    );
}

export default NumberedQuestionWizardStep;
